module.exports = __webpack_public_path__ + "images/accents/accent-box-replay-12b0bdc7a08431d5908d78ec5c78198f.webp";